import { load } from 'cheerio';
import UrlTypes from '@/enums/UrlTypes';

/**
 * KBS provider: stub for HTML-based classification.
 * TODO: implement KBS-specific source detection logic.
 * remove | undefined
 */
export function classifyKbsSource(htmlSource: string): UrlTypes | undefined {
    const $ = load(htmlSource);

    // e.g. check for KBS-specific markers
    // if ($('.kbs_product').length > 0) {
    //   return UrlTypes.PRODUCT;
    // }

    // TODO: add category / category_hub detection

    // Fallback
    return;
}
